import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "search-stt-filter",
  class: "flex items-start w-full justify-between gap-x-4"
}
const _hoisted_2 = { class: "flex gap-x-2 flex-1 items-start" }
const _hoisted_3 = {
  class: "relative",
  style: {"width":"220px"}
}
const _hoisted_4 = {
  class: "relative",
  style: {"width":"220px"}
}
const _hoisted_5 = {
  key: 0,
  style: {"width":"220px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Search, {
          onInput: _ctx.onSearch,
          onClear: () => _ctx.onSearch(''),
          value: _ctx.form.search,
          placeholder: _ctx.$t('cariStt.filterSearchPlaceholder'),
          class: "flex flex-row items-center w-full"
        }, null, 8, ["onInput", "onClear", "value", "placeholder"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_CustomDropdown, {
          selectedItem: _ctx.form.lastStatus,
          options: _ctx.lastStatusList,
          placeholder: _ctx.$t('cariStt.filterLastStatus'),
          onSelect: _ctx.onSelectStatus
        }, null, 8, ["selectedItem", "options", "placeholder", "onSelect"])
      ]),
      (!_ctx.isPosAccount)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_CustomDropdown, {
              selectedItem: _ctx.form.scanLocation,
              options: _ctx.locationArea,
              placeholder: _ctx.$t('cariStt.filterLocation'),
              onSelect: _ctx.onSelectLocation
            }, null, 8, ["selectedItem", "options", "placeholder", "onSelect"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_LpButton, {
      title: _ctx.$t('cariStt.processManifestButton'),
      color: "red-lp-100",
      textColor: "white",
      disabled: _ctx.disabled,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit')))
    }, null, 8, ["title", "disabled"])
  ]))
}